var LazyLoad = require('vanilla-lazyload');

var lazyLoad;

(function () {
    if (typeof window.CustomEvent === 'function') {
        return false;
    }

    function CustomEvent(event, params) {
        var evt = document.createEvent('CustomEvent');
        // eslint-disable-next-line no-param-reassign
        params = params || {bubbles: false, cancelable: false, detail: undefined};
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
})();

module.exports = {
    init: () => {
        if (lazyLoad) {
            lazyLoad.update();
        } else {
            // threshold: distance in pixels added to the visible viewport, important when determining intersections
            // cancel_on_exit: defines whether or not to cancel the download of the images that exit the viewport while they are still loading
            lazyLoad = new LazyLoad({
                elements_selector: 'img[data-src]:not(.loaded)',
                threshold: 50,
                cancel_on_exit: false
            });
        }
    },
    getInstance: () => lazyLoad,
    load: LazyLoad.load
};
